module.exports = __webpack_public_path__ + "15_ldav.png?810f3b0651dab8a663c61f29ce7d2273";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/15_ldav.png
// module id = 156
// module chunks = 0